module.exports = __webpack_public_path__ + "static/media/IMG_0109-01.6ecd1678.jpg";